import _ from 'lodash'

import { Dictionary } from '../../utils/types'

import { ColumnSorting } from './types'

export const sortParam = (sorting: Dictionary<ColumnSorting>) =>
  _.head(
    _.reduce(
      sorting,
      (acc, value, key) => {
        return [
          ...acc,
          {
            name: key,
            type: value.order === 'ascend' ? 'asc' : 'desc'
          }
        ]
      },
      [] as any
    )
  )
